export default "__VITE_ASSET__5e37c910__"